import React from 'react';
import { Stack, Chip, Typography } from '@mui/material';
import copyToClipboard from 'copy-to-clipboard';
import { enqueueSnackbar } from 'notistack';
import first from 'lodash/first';
import { StripeCustomerChip } from './StripeCustomerChip';
import { HubspotDealLink } from '../../Venue/components';
import { LoginAsUserButton } from '../../../components/LoginAsUserButton';

export const Header = ({ organization }) => {
  const onClickIdChip = () => {
    copyToClipboard(organization.id);
    enqueueSnackbar(`Copied ${organization.id} to clipboard`);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        padding={2}
        flexWrap="wrap"
      >
        <Chip
          clickable
          onClick={onClickIdChip}
          variant="outlined"
          label={`ID ${organization.id}`}
        />
        <Typography
          variant="h2"
          sx={{ margin: '16px' }}
          color={organization.discardedAt ? 'textSecondary' : 'textPrimary'}
        >
          Organization: {organization.discardedAt ? '(Archived) ' : ''}{' '}
          {organization.name}
        </Typography>
        <StripeCustomerChip organization={organization} />
        {organization.hubspotDealId && (
          <HubspotDealLink dealId={organization.hubspotDealId} />
        )}
      </Stack>
      <LoginAsUserButton user={first(organization.users)} />
    </div>
  );
};
